import { Control, Grouping, Service } from '@yleisradio/areena-types';
import { useUILanguage } from 'hooks/useUILanguage';
import { MenuSection } from './MenuSection';
import styles from './SubMenu.module.scss';
import { shortcutsGrouping } from './ShortcutData/shortcuts';
import {
  MobileMenuSection,
  MenuType,
} from './MobileMenuBarItems/MobileMenuSection';
import { useRouter } from 'next/router';

interface SubMenuGroupingProps {
  currentPath: string;
  personalMenu: Control[];
  trailingMenus: Control[];
  subMenus: Grouping[];
  service: Service;
  toggleSubMenu(): void;
}

export const SubMenu: React.FunctionComponent<SubMenuGroupingProps> = ({
  currentPath,
  personalMenu,
  trailingMenus,
  subMenus,
  service,
  toggleSubMenu,
}) => {
  const { query } = useRouter();
  const language = useUILanguage();

  return (
    <div className={styles.subMenuWrapper}>
      <MobileMenuSection
        menuType={MenuType.PersonalMenu}
        controls={personalMenu}
        toggleSubMenu={toggleSubMenu}
      />
      {subMenus.map((subMenu) =>
        subMenu.groupings.map((section) => (
          <MenuSection
            grouping={section}
            key={section.tag}
            toggleSubMenu={toggleSubMenu}
          />
        ))
      )}
      <MenuSection
        grouping={shortcutsGrouping(language, currentPath, query, service)}
        toggleSubMenu={toggleSubMenu}
      />
      <MobileMenuSection
        menuType={MenuType.TrailingMenu}
        controls={trailingMenus}
        toggleSubMenu={toggleSubMenu}
      />
    </div>
  );
};
